import { Tab } from "@headlessui/react";
import React, { ChangeEvent, FC, Fragment, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import ProfileBookingCard from "./ProfileBookingCard";
import useProfileBookings from "hooks/useProfileBookings";

export default function ProfileBookings() {
  let categories = ["approved", "pending", "cancelled"];

  const { isLoading, credentials, minHourBeforeCancel, currentList, isEnd, setTabIndex, _onCancelBooking, _onPressShowMore } = useProfileBookings();

  const { t } = useTranslation();

  return (
    <div className="listingSection__wrap">
      <div>
        <h2 className="text-2xl font-semibold">{t("bookings")}</h2>
        <span className="block mt-2 text-neutral-500 dark:text-neutral-400">{t("bookings_desc")}</span>
      </div>
      <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

      <div>
        <Tab.Group>
          <Tab.List className="flex space-x-1 overflow-x-auto">
            {categories.map((item, index) => (
              <Tab key={item} as={Fragment}>
                {({ selected }) => (
                  <button
                    onClick={() => {
                      setTabIndex(index);
                    }}
                    className={`flex-shrink-0 block !leading-none font-medium px-5 py-2.5 text-sm sm:text-base sm:px-6 sm:py-3 capitalize rounded-full focus:outline-none ${
                      selected
                        ? "bg-secondary-900 text-secondary-50 "
                        : "text-neutral-500 dark:text-neutral-400 dark:hover:text-neutral-100 hover:text-neutral-900 hover:bg-neutral-100 dark:hover:bg-neutral-800"
                    } `}>
                    {t(item)}
                  </button>
                )}
              </Tab>
            ))}
          </Tab.List>
          <Tab.Panels>
            <Tab.Panel className="">
              <div className="mt-8 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-2">
                {currentList?.map((item: any, index: number) => (
                  <ProfileBookingCard key={index} data={item} minHourBeforeCancel={minHourBeforeCancel} _onCancelBooking={_onCancelBooking} credentials={credentials} />
                ))}
              </div>
              <div className="flex mt-11 justify-center items-center">
                {!isEnd ? (
                  <ButtonSecondary loading={isLoading} onClick={_onPressShowMore}>
                    {t("showMore")}
                  </ButtonSecondary>
                ) : (
                  <span className="text-base font-semibold text-neutral-500 dark:text-neutral-400">{t("profile_no_more")}</span>
                )}
              </div>
            </Tab.Panel>
            <Tab.Panel className="">
              <div className="mt-8 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-2">
                {currentList?.map((item: any, index: number) => (
                  <ProfileBookingCard key={index} data={item} allowUpload={true} minHourBeforeCancel={minHourBeforeCancel} _onCancelBooking={_onCancelBooking} />
                ))}
              </div>
              <div className="flex mt-11 justify-center items-center">
                {!isEnd ? (
                  <ButtonSecondary loading={isLoading} onClick={_onPressShowMore}>
                    {t("showMore")}
                  </ButtonSecondary>
                ) : (
                  <span className="text-base font-semibold text-neutral-500 dark:text-neutral-400">{t("profile_no_more")}</span>
                )}
              </div>
            </Tab.Panel>
            <Tab.Panel className="">
              <div className="mt-8 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-2">
                {currentList?.map((item: any, index: number) => (
                  <ProfileBookingCard key={index} data={item} />
                ))}
              </div>
              <div className="flex mt-11 justify-center items-center">
                {!isEnd ? (
                  <ButtonSecondary loading={isLoading} onClick={_onPressShowMore}>
                    {t("showMore")}
                  </ButtonSecondary>
                ) : (
                  <span className="text-base font-semibold text-neutral-500 dark:text-neutral-400">{t("profile_no_more")}</span>
                )}
              </div>
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </div>
  );
}
